<a routerLink="/" class="desktop">
  <img src="/assets/rw-logo-top-bar-desktop.png" />
</a>

<div class="centre">
  <a routerLink="/">
    <img src="/assets/rw-logo-top-bar.png" class="logo" />
    <div class="app-headline">App Marketplace</div>
  </a>
  <realwear-cloud-marketplace-button
    class="upload-button"
    [beat]="true"
    [icon]="faUpload"
    value="Upload your own app"
    (click)="navigateTo('https://realwear.com/developer')">
  </realwear-cloud-marketplace-button>
</div>

<div class="search_btn"></div>
